import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import CardImage from '../../../../assets/timerCard-gray.png';
import CardImageOnHover from '../../../../assets/timerCard.png';

export default function ModuleCard(props) {
  const [hover, setHover] = useState(false);
  return (
    <div className={`module-listitem ${props.selected ? 'selected' : ''}`}>
      <div
        className="module-container"
        onClick={() => props.handler()}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      >
        <div
          className="module-image"
          style={{
            backgroundImage: `url(${
              props.selected
                ? CardImageOnHover
                : hover
                ? CardImageOnHover
                : CardImage
            })`,
          }}
        />
        <div className="module-content flex-width-auto ">
          <div className="module-subject uppercase">{props.subject}</div>
          <div className="module-title">{props.subjectTitle}</div>
          <span className="module-text uppercase">Module {props.module}</span>
        </div>
      </div>
    </div>
  );
}

ModuleCard.propTypes = {
  module: PropTypes.string,
  subjectTitle: PropTypes.string,
  subject: PropTypes.string,
  handler: PropTypes.func,
  selected: PropTypes.bool,
};
